import { BookingExternalSources } from "./BookingExternalSources";

export const BookingSources = {
  OBBY: "obby",
  WIDGET: "widget",
  PRIVATE: "private",
  ...BookingExternalSources
};
